/**
 * Zone flags configuration
 * This file must be imported before zone.js in polyfills.ts
 */

// Disable zone.js patching for specific passive events to prevent warnings
// This helps avoid "Unable to preventDefault inside passive event listener" warnings
(window as any).__zone_symbol__PASSIVE_EVENTS = ['scroll', 'wheel', 'touchstart', 'touchmove'];
